// extracted by mini-css-extract-plugin
export var alert = "LoginDialog-module--alert--47G7F";
export var box = "LoginDialog-module--box--atgaa";
export var component = "LoginDialog-module--component--AYONX";
export var description = "LoginDialog-module--description---Btv0";
export var headline = "LoginDialog-module--headline--JYcQS";
export var list = "LoginDialog-module--list--kxrCd";
export var logo = "LoginDialog-module--logo--3Z9TE";
export var nav = "LoginDialog-module--nav--x50-X";
export var wrapper = "LoginDialog-module--wrapper--OKWLK";